// autogenerated by channel_search/generate.py -- do not edit
import { SkillsListRequest } from "@skydio/pbtypes/pbtypes/gen/skills/skills_list_request_pb";
export { SkillsListRequest };

export const SKILLS_LIST_REQUEST_PB = {
  channel: "SKILLS_LIST_REQUEST_PB",
  channelId: 4503,
  type: SkillsListRequest.deserializeBinary
};
